<template>
    <div class="bg_main">
        <v-container>
            <v-card class="card-orders-list">
                    <v-card-title class="pb-0 text-family  text-pantone font-weight-bold">Mi perfil</v-card-title>
                    <v-card-subtitle class="grey--tex float-left text-family my-0">Actualizar tu información personal</v-card-subtitle>
                    <v-divider class="my-10"></v-divider> 
                <v-card-text>
                    <v-form ref="formProfile" v-if="user != null" v-model="formValid">
                        <v-container>
                            <v-row class="mb-4">
                                
                                <h2 for="" class="label-form text-family text-center w-100">Información</h2>

                                <v-col cols="12" class="text-center">
                                        
                                
                                    <v-avatar class="rounded perfil_letra_sub text-family" size="180" >
                                        <img
                                            v-if="user.avatar_path != null &&  user.avatar != 'null' && !uploading"
                                            :src="user.avatar_path"
                                            :alt="user.usuario"
                                        >
                                        <span class="text-pantone" v-if="user.avatar_path == null || user.avatar == 'null' && !uploading">{{getProfileLetterName()}}</span>
                                    </v-avatar>
                                    <v-btn
                                    elevation="2"
                                    icon
                                    style="position:absolute;z-index:10;background-color:white;margin-left: -15px;margin-top: -15px;"
                                    >
                                        <div class="d-flex justify-center align-items-center" style="margin-left:10px;margin-bottom:0px">

                                            <v-file-input
                                            outlined
                                            hide-input
                                            chips
                                            counter
                                            prepend-icon="mdi-pencil"
                                            v-model="file"
                                            :loading="uploading"
                                            accept="image/*"
                                            placeholder="Actualizar fotografia de perfil"
                                            @change="onUploadFile"
                                            :error="hasError"
                                            :error-messages="errorMessage"
                                            >

                                            </v-file-input>
                                        </div>
                                    </v-btn>

                                </v-col>
                                <label for="" class="text-family text-center w-100">Tipo de archivos permitidos: png, jpg, jpeg.</label>
                                    <!-- <label for="" class="label-form text-family">"Fotografía de perfil</label> -->
                                    


                            </v-row>

                            <v-divider class="divider_punteado my-6"></v-divider> 

                            <v-row>
                                <v-col cols="12" md="6" >
                                    <label for="" class="label-form text-family">Nombre de usuario</label>
                                    <v-text-field
                                        outlined required
                                        v-model="user.usuario"
                                        disabled
                                        :rules="[formValidator.username.required, formValidator.username.min_max, formValidator.username.valid_char]"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <label for="" class="label-form text-family">Correo electrónico</label>
                                    <v-text-field
                                        outlined required
                                        v-model="user.email"
                                        type="email"
                                        placeholder="Proporciona un correo electrónico válido."
                                        hint="¡Asegúrate de escribir bien tu correo!."
                                        title="El correo que proporciones será el medio por el cual nos estaremos comunicando contigo, en caso de ser necesario. Por tal razón, asegúrate de que esté correctamente escrito."
                                        :rules="[formValidator.email.required, formValidator.email.valid_email]"
                                    />
                                </v-col>
                                <template v-if="user.tipo_persona === 'fisica'">
                                    <v-col cols="12" md="4">
                                        <label for="" class="label-form text-family">Nombre(s)</label>
                                        <v-text-field
                                            outlined required
                                            v-model="user.nombres"
                                            :disabled="true"
                                            :rules="[formValidator.name.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <label for="" class="label-form text-family">Apellido paterno</label>
                                        <v-text-field
                                            outlined required
                                            v-model="user.apellido_paterno"
                                            :disabled="true"
                                            :rules="[formValidator.lastname_pat.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <label for="" class="label-form text-family">Apellido materno</label>
                                        <v-text-field
                                            outlined required
                                            v-model="user.apellido_materno"
                                            :disabled="true"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <label for="" class="label-form text-family">CURP</label>
                                        <v-text-field
                                            outlined required
                                            v-model="user.curp"
                                            :disabled="true"
                                            :rules="[formValidator.curp.required, formValidator.curp.ws_validate]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <label for="" class="label-form text-family">RFC</label>
                                        <v-text-field
                                            outlined
                                            v-model="user.rfc"
                                            :rules="[formValidator.rfc.physic_pattern_valid]"
                                        />
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined required
                                            v-model="user.nombres"
                                            label="Nombre de la razón social"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            required outlined
                                            v-model="user.rfc"
                                            label="* RFC"
                                            disabled
                                        />
                                    </v-col>
                                </template>

    <!--                            <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined required
                                        v-model="user.password"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        label="* Contraseña"
                                        placeholder="Asegurate de escribir tu actual contraseña para aplicar los cambios"
                                        :rules="[formValidator.password.required]"
                                    />
                                </v-col>-->
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn :color="pantone" class="mx-2 white--text montserrat text-none" link :to="{name: 'home'}" large>
                                        Cancelar
                                    </v-btn>
                                    <v-btn :color="pantoneBlack" class="mx-2 white--text montserrat text-none" large @click="saveProfile()">
                                        Guardar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import * as Storage from 'bestgob-core/core/storage'
    import Constants from "bestgob-core/core/constants";
    import registerFormValidator from "bestgob-core/form/register.form.validator";
    import {Auth} from "bestgob-core/api";

export default {
    name: "UserProfile",

    data() {
        return {
            formValid: false,
            user: null,
            showPassword: false,
            formValidator: registerFormValidator,

            file: null,
            uploading: false,
            hasError: false,
            errorMessage: '',
            pantone: '#ff8400',
            pantoneBlack: '#15212F'
        }
    },

    computed: {
        ...mapState({accountStore: state => state.account})
    },

    mounted() {
        this.user = JSON.parse(Storage.getItem(Constants.KEY_USER))
        delete this.user.access_token
    },

    created() {
        this.$gtag.event('perfil_usuario', { method: 'Google' }) // Google Analytics
    },

    methods: {
        ...mapActions('account', ['postUserProfile']),

        saveProfile(){
            this.$refs.formProfile.validate();

            if (this.formValid){
                Object.keys(this.user).forEach(key => {
                    if (this.user[key] === null){
                        delete this.user[key]
                    }
                })

                this.user['url_redirect'] = window.location.origin
                this.postUserProfile(this.user)
            }
        },

        getUserAvatar(){
            return process.env.VUE_APP_BASE_URL+this.user.avatar
        },

        getProfileLetterName(){
            if (this.user){
                var letra = `${this.user.nombres}`;
                return letra.substring(0,1);
            }

            return ''
        },

        onUploadFile(file){
            if (file != null){
                this.uploading = true

                Auth.updateProfileAvatar({qqfile: file})
                    .then(result => {
                        this.uploading = false
                        this.user.avatar = result.file_name
                        this.user.avatar_path = result.file_path
                    })
                    .catch(error => {
                        this.uploading = false
                        this.hasError = true
                        this.errorMessage = error.message
                    })

            }else {
                this.user.avatar = null
                this.user.avatar_path = null
                this.hasError = false
                this.errorMessage = null
            }
        },
    },
}
</script>

<style >
   
 

    .card-orders-list {
        min-height: 85vh;
    }
    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        padding: .9rem  1rem !important;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        width: 100%;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        font-family: 'PoppinsRegular' !important;

        border: 1px  solid #ff8400 !important;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */

    .montserrat{
        font-family: "Montserrat" !important;
    }

    .v-application.fondo_login fieldset{
        /* border-bottom: 0px !important */
    }
    /* .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        min-height: unset !important;
    } */

    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
    }

    .v-text-field--focused{
        transition: unset !important;   
    }
    .text-pantone{
        color: #B08C55;
    }
    .text-family{
        font-family: 'PoppinsRegular' !important;
    }
    .w-100{
        width: 100%;
    }
    .label-form{
        color: black !important;
        font-family: 'PoppinsRegular';
        font-weight: 500;
    }
</style>
